import PropTypes from 'prop-types';
import { Box, Typography, Tooltip, IconButton } from '@mui/material';
import AutorenewIcon from '@mui/icons-material/Autorenew';

const PollingStatus = ({ pollInterval, countdown, isPolling, onRefresh }) => (
	<Box
		sx={{
			display: 'flex',
			alignItems: 'center',
			mb: 1,
			px: 1,
			py: 0.5,
			borderRadius: 1,
			bgcolor: 'background.paper',
			border: '1px solid',
			borderColor: 'grey.200',
			boxShadow: 1,
			gap: 1.5,
			minHeight: 40,
			minWidth: 220,
		}}
	>
		<Tooltip title={isPolling ? 'Refreshing...' : 'Refresh now'}>
			<span>
				<IconButton
					color='info'
					size='small'
					onClick={isPolling ? undefined : onRefresh}
					disabled={isPolling}
					sx={{
						p: 0.5,
						mr: 1,
						transition: 'opacity 0.2s',
						opacity: isPolling ? 0.5 : 1,
						'&:hover': { opacity: isPolling ? 0.5 : 0.7 },
					}}
					aria-label='Refresh'
				>
					<AutorenewIcon
						sx={{
							fontSize: 22,
							animation: isPolling ? 'spin 1s linear infinite' : undefined,
							'@keyframes spin': { '100%': { transform: 'rotate(360deg)' } },
						}}
					/>
				</IconButton>
			</span>
		</Tooltip>
		<Box>
			<Typography variant='body2' sx={{ fontWeight: 500, lineHeight: 1 }}>
				Auto-refreshing
			</Typography>
			<Typography
				variant='caption'
				color='text.secondary'
				sx={{ lineHeight: 1 }}
			>
				Every {pollInterval}s • Next: {countdown}s
			</Typography>
		</Box>
	</Box>
);

PollingStatus.propTypes = {
	pollInterval: PropTypes.number.isRequired,
	countdown: PropTypes.number.isRequired,
	isPolling: PropTypes.bool.isRequired,
	onRefresh: PropTypes.func.isRequired,
};

export default PollingStatus;
